<template>
    <b-button-group size="sm" class="btn-block">
        <b-button
            :pressed="otherMissionFilter === 'otm'"
            variant="outline-secondary"
            @click="updateOtherMissionFilter('otm')"
        >
            Toutes
        </b-button>
        <b-button
            :pressed="otherMissionFilter === 'ecf'"
            variant="outline-primary"
            @click="updateOtherMissionFilter('ecf')"
        >
            ECF
        </b-button>
    </b-button-group>
</template>

<script>
import {mapState} from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater.vue'

export default {
    name: 'OtherMissionFilter',

    mixins: [DataUpdater],

    computed: {
        ...mapState({
            otherMissionFilter: (state) => state.browsing.otherMissionFilter,
        }),
    },

    methods: {
        updateOtherMissionFilter(value) {
            this.$store.commit('browsing/SET_OTHER_MISSION_FILTER', value)
            this.$root.$refs.otherMissionsTable.getItems()
        },
    },
}
</script>

<style scoped></style>
